export default __webpack_public_path__ + "static/media/14.107cd7f8.png";